import { UserState } from './reducer';

export const initialState: UserState = {
  status: 'unused',
  error: null,
  user: null
};
